import React from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'
import { TimeSettingsRouter } from './settings/_router'
import { TimeValidationRouter } from './validation/_router'

export const WorkingTimeRouter = React.memo(() => (
  <SubRouter loggedIn>
    <Route path='validation/*' element={<TimeValidationRouter />} />
    <Route path='settings/*' element={<TimeSettingsRouter />} />
  </SubRouter>
))
